/**
 * Created by staffanrantzow on 17/03/16.
 */

/* @flow */
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import Translate from 'react-translate-component';
import ErrandRow from './errand-row';
import Spinner from 'components/spinner/spinner';
import GeneralError from 'components/general-error/general-error';
import InvoiceService from 'frilans-finans/invoices/invoice-service';
import ShowMoreButton from './show-more-button';
import { proxyCounterpart } from '../../../scripts/proxyCounterpart';

export class ErrandTable extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired
  };

  constructor (props) {
    super(props);

    this.state = {
      fetchingInitial: true,
      fetchError: false,
      invoices: [],
      pendingRequest: null,
      showMoreList: {
        invoiceId: null,
        show: false
      },
      meta: {
        count: 0,
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0
      }
    };

    this.getInvoices = this.getInvoices.bind(this);
    this.handleError = this.handleError.bind(this);
    this.setShowMoreList = this.setShowMoreList.bind(this);
    this.resetShowMoreList = this.resetShowMoreList.bind(this);
    this.renderTable = this.renderTable.bind(this);
    this.renderTableRow = this.renderTableRow.bind(this);
    this.renderShowMoreBtn = this.renderShowMoreBtn.bind(this);
  }

  componentDidMount () {
    this.getInvoices();
  }

  componentWillUnmount () {
    if (this.state.pendingRequest && this.state.pendingRequest.cancel) {
      this.state.pendingRequest.cancel();
    }
  }

  getInvoices () {
    const page = +this.state.meta.currentPage + 1;
    const userId = +this.props.user.id;

    const pendingRequest = InvoiceService.get(userId, null, page, 0, 1, 2, null, true);

    pendingRequest.promise
      .then(this.handleResponse.bind(this))
      .catch(this.handleError);

    this.setState({
      pendingRequest: pendingRequest
    });
  }

  handleResponse (response) {
    const invoicesMerged = [
      ...this.state.invoices,
      ...response.collection
    ];
    this.setState({
      fetchingInitial: false,
      fetchError: false,
      invoices: invoicesMerged,
      meta: response.meta
    });
  }

  handleError (error) {
    if (error.response !== undefined) {
      this.setState({
        fetchError: true
      });
    }
  }

  noInvoicesRow () {
    return (
      <div className='errand-table-no-more-info'>
        {proxyCounterpart('ERRAND_TABLE_NO_INVOICES')}
      </div>
    );
  }

  noMoreInfoRow () {
    return (
      <div className='errand-table-no-more-info'>
        {proxyCounterpart('ERRAND_TABLE_ALL_INVOICES_ARE_LOADED')}
      </div>
    );
  }

  renderShowMoreBtn () {
    if (this.state.meta.currentPage === this.state.meta.totalPages) {
      return this.noMoreInfoRow();
    }

    if (!this.state.meta || this.state.invoices.length <= 0) {
      return this.noInvoicesRow();
    }

    if (this.state.fetchingInitial ||
      !this.state.meta.currentPage ||
      this.state.meta.currentPage >= this.state.meta.totalPages
      ) {
      return null;
    }

    return (
      <ShowMoreButton
        text={proxyCounterpart('ERRAND_TABLE_TABLE_SHOW_MORE_INVOICES')}
        loading={this.state.fetchingInitial || false}
        callback={this.getInvoices}
      />
    );
  }

  setShowMoreList (invoiceId) {
    const invoiceIdSet = this.state.showMoreList.invoiceId === invoiceId;
    this.setState({
      showMoreList: {
        invoiceId: invoiceIdSet ? null : invoiceId,
        show: !invoiceIdSet
      }
    });
  };

  resetShowMoreList () {
    this.setState({
      showMoreList: {
        invoiceId: null,
        show: false
      }
    });
  }

  getContent () {
    if (this.state.fetchError) {
      return (<GeneralError />);
    }
    if (this.state.fetchingInitial) {
      return this.renderLoader();
    }
    if (this.state.invoices.length === 0) {
      return this.renderNoResult();
    }
    return this.renderTable();
  }

  renderLoader () {
    return (
      <div className='loader-wrapper'>
        <Spinner />
      </div>
    );
  }

  renderNoResult () {
    return (
      <p className='info'><Translate content='NO_INVOICES'/></p>
    );
  }

  renderTableRow (invoice, i) {
    return <ErrandRow
      key={i}
      invoice={invoice}
      toggleShowMoreList={this.setShowMoreList}
      resetShowMoreList={this.resetShowMoreList}
      showMoreList={this.state.showMoreList}
    />;
  }

  renderTable () {
    return (
      <div className='errand-table-wrapper'>
        <div className='errand-flex-table'>
          {this.state.invoices.map((invoice, i) => this.renderTableRow(invoice, i))}
        </div>
        {this.renderShowMoreBtn()}
      </div>
    );
  }

  render () {
    var content = this.getContent();
    return this.state.invoices.length
      ? (<div className="current-invoices">
        <div className='current-invoices-title'>
          <Translate content='CURRENT_ERRANDS'/>
        </div>
        {content}
      </div>)
      : null;
  }
}

function mapStateToProps (state) {
  return {
    user: state.user
  };
};

export default connect(
  mapStateToProps
)(ErrandTable);



/** WEBPACK FOOTER **
 ** ./src/views/activities-view/errand-table/errand-table.js
 **/